import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Aboutus from "./components/Aboutus";
import Contactus from "./components/Contactus";
import Privacypolicy from "./components/Privacypolicy";
import TermsAndConditions from "./components/TermsCondition";
import CancellationRefunds from "./components/CancelationRefunds";
import Product from "./components/Product";
import SKUPage from "./components/SKu";

function App() {
  return (
    <div className="hideenscrollmain overflow-auto h-[100vh]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="aboutus/" element={<Aboutus />} />
          <Route path="contactus/" element={<Contactus />} />
          <Route path="product/" element={<Product/>}/>
          <Route path="sku/" element={<SKUPage />} />
          <Route path="privaypolicy/" element={<Privacypolicy />} />
          <Route path="termscondition/" element={<TermsAndConditions />} />
          <Route path="cancelationrefunds/" element={<CancellationRefunds />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;